<template>
  <div class="card-item">
    <AntCard :title="title">
      <slot></slot>
      <template class="ant-card-actions" slot="actions">
        <div class="map-link" @click="$emit('mapClicked')">
          <MapIcon type="map" /><span>zur Kartenansicht</span>
        </div>
      </template>
    </AntCard>
  </div>
</template>

<script>
import AntCard from 'ant-design-vue/lib/card'
import 'ant-design-vue/lib/card/style/index.css'
import { MapIcon } from 'vue-feather-icons'

export default {
  components: {
    AntCard,
    MapIcon
  },
  props: {
    title: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.card-item {
  width: 48%;
  margin: 1%;
}
:deep(a) {
  color: #eb003c;
}
:deep(.ant-card-body) {
  padding: 12px;
  zoom: 1;
}
:deep(.ant-card-actions > li > span:hover) {
  color: #eb003c;
}
.map-link {
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    padding: 0 6px;
  }
}
</style>
